import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { createApiCallEffects } from '../../../common/store/generic.effects';
import { ExportApiService } from './export.api.service';
import { ExportAction, exportActions } from './export.actions';

@Injectable()
export class ExportEffects {
  constructor(
    private readonly exportApiService: ExportApiService,
    private readonly actions$: Actions<ExportAction>,
  ) {}

  exportToCsv = createApiCallEffects(
    this,
    this.actions$,
    exportActions.exportToCsv,
    this.exportApiService.exportToCsv,
  );
}
